import { render, staticRenderFns } from "./IconSubstitute.vue?vue&type=template&id=1a389349&"
import script from "./IconSubstitute.vue?vue&type=script&lang=js&"
export * from "./IconSubstitute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports